<template>
    <div class="time-picker-component" :class="{'is-disabled': disabled}">
      <input type="text" :value="timeString" :disabled :class="{'bg-warning': wasReset}" :tabindex="tabindex" @blur="timeChanged" @focus="timeFocus" @keyup.enter="timeChanged" @keydown.esc="cancelChanges">
    </div>
  </template>
    
  <script>
  import { ref, computed, watch } from 'vue'
  import moment from 'moment/moment';
  
  export default {
    components: { },
    props: {
        modelValue: {
            type: [String, null],
            required: false,
        },
        tabindex: {
            type: [Number, null],
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, {emit}) {
        const timeString = ref(props.modelValue);
        const wasReset = ref(false);
        let prevEmit = null;
        const resetTime = () => {
            // console.log('resetTime', props.modelValue);
            timeString.value = props.modelValue;
            prevEmit = props.modelValue;
        }
        const emitNewValue = (value) => {
            if (value !== prevEmit) {
                // console.log('emitNewValue', value);
                emit('update:modelValue', value);
                prevEmit = value;
            } else {
                // console.log('don\'t emitNewValue', value);
            }
        };

        watch(() => props.modelValue, () => {
            wasReset.value = true;
            setTimeout(() => {
                wasReset.value = false;
            }, 1000);
            resetTime();
        });
        resetTime();

        const timeChanged = (e) => {
            let newValue = e.target.value;
            if (newValue.match(/^\d{1}$/) !== null) {
                newValue = '0' + newValue + ':00';
            } else if (newValue.match(/^\d{2}$/) !== null) {
                newValue = newValue + ':00';
            } else if (newValue.match(/^\d{3}$/) !== null) {
                newValue = '0' + newValue;
            } 
            if (newValue.match(/^\d{4}$/) !== null) {
                if (newValue < '2400') {
                    newValue = moment(newValue, 'HHmm').format('HH:mm');
                }
            }
            
            if (newValue.match(/^\d{2}:\d{2}$/) !== null) {
                // ensure that minutes are in 5 minute intervals
                const minutes = parseInt(newValue.split(':')[1]);
                const newMinutes = Math.round(minutes / 5) * 5;
                newValue = `${newValue.split(':')[0]}:${newMinutes.toString().padStart(2, '0')}`;
            }

            if (newValue === '' || (newValue.match(/^\d{2}:\d{2}$/) !== null && newValue <= '23:59')) {
                emitNewValue(newValue);
                if (timeString.value === newValue) {
                    // force update by setting it to something else first
                    timeString.value = '-1';
                }
                timeString.value = newValue;
            } else {
                // change back to previous value, and force update by setting it to something else first
                timeString.value = '-1';
                timeString.value = prevEmit;
            }
        }

        const cancelChanges = () => {
            timeString.value = '';
            timeString.value = prevEmit;
        }

        // selecte all text when focus
        const timeFocus = (event) => {
            event.target.select();
        }
        return {
            wasReset,
            timeString,
            timeChanged,
            cancelChanges,
            timeFocus,
        };
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .time-picker-component {
    input {
      width: 40px;
      transition: background-color 0.5s ease;
      background-color: white;
      border: 1px solid #767676;
      &:disabled {
        background-color: #eeeeee;
        border-color: #cccccc;
        pointer-events: none;
      }
    }
    &.is-disabled {
      cursor: not-allowed;
    }
  }
  </style>